<template>
  <admin-wrapper
    title-translation-path="admin.MASTERPLAN_RP"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    @save="save"
  >
    <template #masterplanRpDataSource.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="selectedDataSource" />
      </v-col>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'MasterplanRpSettings',
  components: {
    AdminWrapper,
    DataInput,
  },
  data: () => ({
    isFormFetched: false,
    selectedDataSource: '',
  }),
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
  computed: {
    dataSources: get('layers/metadata'),
    isModuleEnabled: get('admin/settingsValues@masterplan_rp_module_enabled'),
    // Nazwa ustawienia nie jest zwracana, więc na razie ją hardocoduję
    // dataSourceSettingsName: get('admin/modulesMapping@masterplan_rp.selected_datasource_name'),
    dataSourceSettingsName() {
      return 'masterplan_rp_datasource';
    },
    dataSourcesArray() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.scope === 'core' && !dataSource.module
      );
    },
    inputs() {
      return [
        {
          name: 'masterplanRpDataSource',
          translationPath: 'admin.datasourcesTypemasterplan_rp',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.dataSourcesArray,
          itemValue: 'name',
          itemText: 'verbose_name',
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'masterplan_rp_module_enabled',
        translationPath: 'admin.MASTERPLAN_RP',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', {
          suffix: this.$i18n.t('admin.MASTERPLAN_RP'),
        }),
      };
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  methods: {
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    async init() {
      await Promise.all([this.getModulesMapping(), this.getDataSources()]);
      if (this.isModuleEnabled) {
        await this.updateSelectedDataSource();
      }
      this.isFormFetched = true;
    },
    async updateSelectedDataSource() {
      try {
        const r = await this.getDatasourceSettings(this.dataSourceSettingsName);
        const { datasource } = r;
        this.selectedDataSource = datasource;
      } catch {
        this.selectedDataSource = '';
      }
    },
    async save() {
      const payload = { name: this.dataSourceSettingsName, settings: { datasource: this.selectedDataSource } };
      try {
        await this.editDatasourceSettings(payload);
      } catch (error) {
        console.log('  error', error);
      }
    },
  },
};
</script>
